import { Injectable } from '@angular/core'
import { filter, map } from 'rxjs/operators'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root'
})
export class MbOrderSimulateService {

  cart$ = this.activeCartService.getActive()

  constructor (protected activeCartService: ActiveCartService) { }

  getErpPrice (item: any) {
    return this.cart$.pipe(
      filter(cart => !!cart.entries && !cart.erpPricingError),
      map(cart => cart.entries),
      map(entries => entries?.find(entry => entry?.product?.code === item?.product?.code)
      )
    )
  }
}
